module.exports = __webpack_public_path__ + "img/9.620f7322.png";